var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container"},_vm._l((24),function(item,index){return _c('div',{key:index,staticClass:"grid-item",class:{'grid-item-2': (item%3===0),'grid-item-4': (item%6===0)}},[_c('span',[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }